// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__-Sm-f","bigColWidth":"Table_bigColWidth__3bMOB","biggerColWidth":"Table_biggerColWidth__2a0cy","row":"Table_row__3LW85","col":"Table_col__2Qrtc"};